import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Box, Container, Flex, useColorModeValue } from '@chakra-ui/react';
import { Button } from '@peacecover/component';
import StickyHeader from '../components/bar/StickyHeader';
import './LandingPage.css';

const MotionBox = motion(Box);
const MotionHeading = motion('h1');
const MotionText = motion('p');

const PROFILE_CARD_WIDTH = 240;
const PROFILE_CARD_GAP = 18;
const PROFILE_CARD_COUNT = 4;
// 무한 루프용: 카드 1세트 길이만큼 이동하면 다음 세트가 정확히 이어짐
const PROFILE_CARD_TRAVEL_X = (PROFILE_CARD_WIDTH + PROFILE_CARD_GAP) * PROFILE_CARD_COUNT;

const profileCards = [
  { src: '/assets/landing/profile_card_01.png', alt: 'bettie profile card 1' },
  { src: '/assets/landing/profile_card_02.png', alt: 'bettie profile card 2' },
  { src: '/assets/landing/profile_card_03.png', alt: 'bettie profile card 3' },
  { src: '/assets/landing/profile_card_04.png', alt: 'bettie profile card 4' }
];

const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const bg = useColorModeValue('white', '#0D0E12');
  const textColor = useColorModeValue('gray.900', 'white');

  return (
    <Box
      bg={bg}
      color={textColor}
      className="landing-container pt-[env(safe-area-inset-top)]"
      overflowX="hidden"
    >
      <StickyHeader showBackButton={true} />
      {/* 1. Header Section */}
      <Container maxW="container.sm" pt="80px" pb="40px" textAlign="center">
        <MotionHeading
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-[26px] leading-[31px] font-bold text-text-main-lv1 whitespace-pre-line word-break-keep-all"
        >
          {t('Landing.title')}
        </MotionHeading>
        <MotionText
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-[15px] leading-[18px] font-medium text-text-main-lv4 mt-[14px] whitespace-pre-line word-break-keep-all"
        >
          {t('Landing.description')}
        </MotionText>
      </Container>
      {/* 2. Visual Section (Profile Card) */}
      <Flex justify="center" align="center" pb="10px" className="visual-section">
        <MotionBox
          initial={{ opacity: 0, scale: 0.9, rotateY: -10 }}
          animate={{ opacity: 1, scale: 1, rotateY: 0 }}
          transition={{ duration: 1, delay: 0.5, type: 'spring' }}
          className="profile-card-viewport"
        >
          <MotionBox
            animate={{ x: [0, -PROFILE_CARD_TRAVEL_X] }}
            transition={{
              duration: 15,
              ease: 'linear',
              repeat: Number.POSITIVE_INFINITY
            }}
            className="profile-card-track flex items-center"
          >
            {[...profileCards, ...profileCards].map((card, idx) => (
              <img
                key={`${card.src}-${idx}`}
                src={card.src}
                alt={card.alt}
                className="profile-card-image scale-90"
              />
            ))}
          </MotionBox>
        </MotionBox>
      </Flex>
      {/* 4. CTA Section */}
      <Box className="cta-sticky-container px-[20px] pt-[20px] pb-[calc(20px+env(safe-area-inset-bottom))]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold cta-shadow-pulse"
          onClick={() => navigate('/fan-buddy/intro')}
        >
          {t('Landing.createProfileCard')}
        </Button>
      </Box>
      <Box h="120px" /> {/* Bottom Spacing for Sticky Button */}
    </Box>
  );
};

export default LandingPage;
